import { CartsModel } from "../models/carts";

export const calculateOrderProductUnitByCarts = (cartItems: CartsModel[]) => {
  let totalQuantity = 0;
  const startDate = new Date(cartItems[0]?.product?.promotion?.startDate);
  const currentDate = new Date();

  // Only take `getProduct?.quantity` from the first item
  const firstItemGetProductQuantity = cartItems[0]?.getProduct?.quantity ?? 0;

  const isSameDate = (date1: Date, date2: Date): boolean => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate() &&
      date1.getHours() === date2.getHours()
    );
  };

  const isStartDateGreater = (date1: Date, date2: Date): boolean => {
    return date1.getTime() < date2.getTime();
  };

  for (let i = 0; i < cartItems.length; i++) {
    if (isStartDateGreater(startDate, currentDate)) {
      totalQuantity += cartItems[i]?.quantity ?? 0;
      if (i === 0) totalQuantity += firstItemGetProductQuantity; // Only add `getProduct?.quantity` for the first item
    } else if (isSameDate(startDate, currentDate)) {
      if (cartItems[i]?.getProduct) {
        totalQuantity += cartItems[i]?.quantity ?? 0;
        if (i === 0) totalQuantity += firstItemGetProductQuantity; // Only for the first item
      }
    } else {
      totalQuantity += cartItems[i]?.quantity ?? 0;
    }
  }

  return totalQuantity;
};
